/**
 * Analytics tracking utility
 * Allows users to opt-out of analytics tracking via LocalStorage
 */

export const isAnalyticsEnabled = (): boolean => {
  if (typeof window === 'undefined') return true;
  return localStorage.getItem('analytics_disabled') !== 'true';
};

export const disableAnalytics = (): void => {
  localStorage.setItem('analytics_disabled', 'true');
  console.log('📊 Analytics wurde deaktiviert');
};

export const enableAnalytics = (): void => {
  localStorage.removeItem('analytics_disabled');
  console.log('📊 Analytics wurde aktiviert');
};

export const toggleAnalytics = (): void => {
  if (isAnalyticsEnabled()) {
    disableAnalytics();
  } else {
    enableAnalytics();
  }
};

export const getAnalyticsStatus = (): { enabled: boolean; message: string } => {
  const enabled = isAnalyticsEnabled();
  return {
    enabled,
    message: enabled 
      ? '📊 Analytics ist aktiviert' 
      : '🚫 Analytics ist deaktiviert'
  };
};

// Lightweight Event Tracking: versucht plausible und gtag, wenn vorhanden
export const trackEvent = (
  name: string,
  params?: Record<string, any>
): void => {
  try {
    if (!isAnalyticsEnabled()) return;
    // Plausible
    // @ts-ignore
    if (typeof window !== 'undefined' && typeof window.plausible === 'function') {
      // @ts-ignore
      window.plausible(name, { props: params });
    }
    // Google Analytics (gtag)
    // @ts-ignore
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      // @ts-ignore
      window.gtag('event', name, params || {});
    }
  } catch (e) {
    // fail silent
  }
};
